import EDCMainPanel from "../../Components/EDC/EDCMainPanel";
import ManageForm from "../EDCManagement/FormManagement/ManageForm";
import ViewEventSchema from "../EDCManagement/EventSchema/ViewEventSchema";
import SiteSubjectEventLists from "../EDCManagement/FormManagement/FormList/SiteSubjectEventLists";
import FormMetadataDataList from "../EDCManagement/FormManagement/FormMetadata/FormMetadataDataList";
import CustomEditCheckMetaDataList from "../EDCManagement/StudySettings/CustomEditCheck/CustomEditCheckMetaDataList";
import FieldNotificationCheckMetaDataList from "../EDCManagement/StudySettings/FieldNotificationCheck/FieldNotificationCheckDataList";
import ManageQueryDataList from "../EDCManagement/QueryManagementSystem/ManageQueryDataList";
import QueryStatisticsDataList from "../EDCManagement/QueryManagementSystem/QueryStatisticsDataList";
import ManageNotificationDataList from "../EDCManagement/NotificationManagementSystem/ManageNotificationDataList";
import NotificationStatisticsDataList from "../EDCManagement/NotificationManagementSystem/NotificationStatisticsDataList";
import ReportMetadata from "../EDCManagement/StudySettings/ReportMetadata/ReportMetadata";
import StudyDocument from "../EDCManagement/StudyDocument/StudyDocument";
import DerivedVariableDataList from "../EDCManagement/StudySettings/DerivedVariable/DerivedVariableDataList";
import FieldDerivationSchemaLists from "../EDCManagement/StudySettings/AssignFieldDerivation/FieldDerivationSchemaLists";
import AssignSubjectSchemaLists from "../EDCManagement/StudySettings/AssignSubjectGender/AssignSubjectSchemaLists";
import StudyDetails from "../EDCManagement/StudyManagement/StudyDetails";
import SDVStatisticsDataList from "../EDCManagement/SDVManagementSystem/SDVStatisticsDataList";
import OndemandTransfer from "../EDCManagement/DatasetManagement/OndemandTransfer/OndemandTransfer";
import TransferedDatasetList from "../EDCManagement/DatasetManagement/DatasetsTransfer/TransferedDatasetList";
import SchemaReport from "../EDCManagement/FormManagement/ReportManagement/SchemaReport/SchemaReport";
import SubjectReport from "../EDCManagement/FormManagement/ReportManagement/SubjectReport/SubjectReport";
import LabManagementDataList from "../CTMSManagement/LabManagementManagement/LabManagementData/LabManagementDataList";
import StudyDashboard from "./Dashboard/StudyDashboard";
import AuditTrial from "./StudyManagement/AuditTrial";
import FormBuilder from "./FormManagement/FormBuilder/FormBuilder";
import ReviewSettings from "./MedicalReview/ReviewSettings/ReviewSettings";
import TaskManagement from "./MedicalReview/ReviewSettings/TaskManagement";
import MedicalBulkReview from "./MedicalReview/ReviewSettings/MedicalBulkReview";
import TaskSummery from "./MedicalReview/ReviewSettings/TaskSummery";
import InvestigatorSignatureTableData from "./InvestigatorSignature/InvestigatorSignatureTableData";
import ManageFormSDVDataList from "./SDVManagementSystem/FormSDV/ManageFormSDVDataList";
import DatasetListByColumn from "./DatasetManagement/DatasetListByColumn/DatasetListByColumn";
import DatasetByRow from "./DatasetManagement/DatasetByRow/DatasetByRow";
import EventFormAssignment from "./FormManagement/FormAssignment/EventFormAssignment";
import InitiateFormAssignment from "./FormManagement/FormAssignment/InitiateFormAssignment";
import SpecialFormAssignment from "./FormManagement/FormAssignment/SpecialFormAssignment";
import FormFieldGroupDataList from "../Roles/AppsComponant/GlobalFormLibrary/FormFieldGroup/FormFieldGroupDataList";
import QueryOverview from "./QueryManagementSystem/QueryOverview";
import NotificationOverview from "./NotificationManagementSystem/NotificationOverview";
import SiteSubjectStatusList from "./SubjectManagement/SiteSubjectStatusList";
import SiteSubjectDiscontinueHistory from "./SubjectManagement/SiteSubjectDiscontinueHistory";
import SiteSubjectScreenFailedHistory from "./SubjectManagement/SiteSubjectScreenFailedHistory";
import SiteSubjectEventStatusList from "./SubjectManagement/SiteSubjectEventStatusList";
import UnscheduledFormAssignment from "./FormManagement/FormAssignment/UnscheduledFormAssignment";
import Mapper from "./LabManagement/Mapper";
import StudyLabFileManagement from "./LabManagement/FileManagement/StudyLabFileManagement";
import Randomization from "../EIWRSMangement/Randomization/Randomization";

const StudiesPage = ({
  tableRef,
  studyTabs,
  onMouseDown,
  setStudyTabs,
  checkActiveTabData,
  checkActiveDynamicTabData,
  activeStudyTab,
  collapseSidebar,
  setCollpaseSidebar,
  checkHomeActiveTab,
  checkActiveTab,
  checkDynamicActiveTab,
  handleAddNewTab,
}) => {
  return (
    <>
      <section className="middle-content " id="dashboard-section">
        <div className="inner-cont">
          <EDCMainPanel
            setStudyTabs={setStudyTabs}
            studyTabs={studyTabs}
            showSidebar
            activeStudyTab={activeStudyTab}
            collapseSidebar={collapseSidebar}
            setCollpaseSidebar={setCollpaseSidebar}
          />

          {!checkHomeActiveTab() && (
            <StudyDashboard tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("formMetadata") && (
            <FormMetadataDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              handleAddNewTab={handleAddNewTab}
            />
          )}

          {checkDynamicActiveTab("formBuilder") && (
            <FormBuilder
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              ids={checkActiveDynamicTabData("formBuilder")?.idObject}
            />
          )}

          {(checkActiveTab("viewFormLists") ||
            checkActiveTab("viewFormReportLists") ||
            checkDynamicActiveTab("viewEventSchemaFormLists") ||
            checkActiveTab("manageGlobalFormFieldLibrary") ||
            checkActiveTab("editFormFields")) && (
              <ManageForm
                activeTabName={checkActiveTabData}
                checkActiveTab={checkActiveTab}
                checkDynamicActiveTab={checkDynamicActiveTab}
                checkActiveDynamicTabData={checkActiveDynamicTabData}
                tableRef={tableRef}
                onMouseDown={onMouseDown}
                handleAddNewTab={handleAddNewTab}
              />
            )}

          {checkActiveTab("initiateFormAssignment") && (
            <InitiateFormAssignment
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("eventFormAssignment") && (
            <EventFormAssignment
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("unscheduledFormAssignment") && (
            <UnscheduledFormAssignment
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("specialFormAssignment") && (
            <SpecialFormAssignment
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("viewEventSchema") && (
            <ViewEventSchema
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              handleAddNewTab={handleAddNewTab}
            />
          )}

          {checkActiveTab("autoQueryChecks") && (
            <CustomEditCheckMetaDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              category={"query"}
            />
          )}

          {checkActiveTab("notificationChecks") && (
            <CustomEditCheckMetaDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              category={"notification"}
            />
          )}

          {checkActiveTab("inclusionExclusionChecks") && (
            <CustomEditCheckMetaDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              category={"includeExclude"}
            />
          )}

          {checkActiveTab("studyDetail") && <StudyDetails />}
          {checkActiveTab("auditLogs") && (
            <AuditTrial tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("fieldNotificationMail") && (
            <FieldNotificationCheckMetaDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("derivedVariable") && (
            <DerivedVariableDataList
              category="derived"
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("formSDV") && (
            <ManageFormSDVDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              handleAddNewTab={handleAddNewTab}
            />
          )}

          {checkActiveTab("queryOverview") && (
            <QueryOverview
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("manageQuery") && (
            <ManageQueryDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              handleAddNewTab={handleAddNewTab}
            />
          )}

          {checkActiveTab("queryStatistics") && <QueryStatisticsDataList />}

          {checkActiveTab("SDVStatistics") && <SDVStatisticsDataList />}
          {checkActiveTab("principleInvestigatorSignature") && <InvestigatorSignatureTableData
            tableRef={tableRef}
            onMouseDown={onMouseDown}
          />}

          {checkActiveTab("manageNotification") && (
            <ManageNotificationDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              handleAddNewTab={handleAddNewTab}
            />
          )}

          {checkActiveTab("notificationOverview") && (
            <NotificationOverview
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("notificationStatistics") && (
            <NotificationStatisticsDataList />
          )}

          {checkActiveTab("reportMetadata") && <ReportMetadata />}

          {checkActiveTab("assignField") && (
            <FieldDerivationSchemaLists
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("transferedDatasetList") && (
            <TransferedDatasetList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("datasets") && (
            <DatasetListByColumn tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("datasetsByRow") && (
            <DatasetByRow tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("randomizedKitSubject") && (
            <Randomization tableRef={tableRef} onMouseDown={onMouseDown} screenType="edc" />
          )}
          
          {checkActiveTab("subjectStatus") && (
            <SiteSubjectStatusList tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("subjectEventStatus") && (
            <SiteSubjectEventStatusList tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("screenFailedHistory") && (
            <SiteSubjectScreenFailedHistory tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("subjectDiscontinueHistory") && (
            <SiteSubjectDiscontinueHistory tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("onDemandDatasets") && (
            <OndemandTransfer tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("assignGender") && <AssignSubjectSchemaLists />}

          {checkActiveTab("studyDocument") && <StudyDocument />}

          {checkActiveTab("viewSchemaReportLists") && <SchemaReport />}

          {checkActiveTab("viewSubjectReportLists") && <SubjectReport />}

          {checkActiveTab("medicalReviewSettings") && <ReviewSettings tableRef={tableRef} onMouseDown={onMouseDown} />}

          {checkActiveTab("medicalReviewTask") && <TaskManagement tableRef={tableRef} onMouseDown={onMouseDown} handleAddNewTab={handleAddNewTab} status="pending" />}

          {checkActiveTab("medicalReviewSummery") && <TaskSummery tableRef={tableRef} onMouseDown={onMouseDown} handleAddNewTab={handleAddNewTab} status="completed" />}

          {checkActiveTab("MedicalBulkReview") && <MedicalBulkReview tableRef={tableRef} onMouseDown={onMouseDown} handleAddNewTab={handleAddNewTab} status="completed" />}

          {checkActiveTab("labRangeSettings") && (
            <LabManagementDataList
              tableRef={tableRef}
              onMouseDown={onMouseDown}
            />
          )}

          {checkActiveTab("globalFormFieldGroup") && (
            <FormFieldGroupDataList tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("uploadLabData") && (
            <StudyLabFileManagement tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("mapper") && (
            <Mapper tableRef={tableRef} onMouseDown={onMouseDown} />
          )}

          {checkActiveTab("dataEntry") && (
            <SiteSubjectEventLists
              handleAddNewTab={handleAddNewTab}
              tableRef={tableRef}
              onMouseDown={onMouseDown}
              activeTabName={checkActiveTabData("dataEntry")?.idObject}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default StudiesPage;
